export default __webpack_public_path__ + "static/101210-9fd95d788b849d818f8746fbf51fed82.jpg";